import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import AOS from 'aos';

import './index.scss';
import MainContext from '../../contexts/MainContext';
import {
  STARSTAKE_BRANDCLUB_URL,
  SOCIAL_LINK_ICONS as socialIcons
} from '../../config';

import { ReactComponent as Logo } from '../../img/svg/Logos/real-world-funding.svg';
import { ReactComponent as RealWorldFunding } from '../../img/svg/Logos/real-world-funding.svg';

function NewFooter({ hideAnimation = false }) {
  const {
    isRegistered = false,
    hasCreatorAccess = false,
    connect = () => {}
  } = React.useContext(MainContext);

  React.useEffect(() => {
    AOS.refresh();
  }, []);

  const connectWalletHandler = (e) => {
    if (isRegistered) return;
    e.preventDefault();
    connect();
  };

  return (
    <div className="updated-footer-wrapper footer-spacing">
      <div className="alignment-wrapper-footer">
        <div className="join-club-wrapper">
          <div className="detail-main-wrapper">
            <h2
              className="brandclub-title"
              data-aos={hideAnimation ? '' : 'fade-up'}
            >
              Join the official <br />
              Real World Asset Campaign
            </h2>
            <p
              className="interactive-text"
              data-aos={hideAnimation ? '' : 'fade-up'}
            >
              The Real World Asset model tightly links funding with promotion and rewards; it goes beyond traditional crowdfunding. This approach introduces a more effective method for product launches and marketing at large. It blurs the lines between being a backer, a customer, and a brand advocate, especially when everyone has a stake powered by something like RWA bucks. As this model gains traction, its wider ripple effects become increasingly evident—offering much to consider for the future of community-driven products.
            </p>
            <div
              className="join-now-button"
              data-aos={hideAnimation ? '' : 'fade-up'}
            >
              <a
                href={STARSTAKE_BRANDCLUB_URL}
                target="_blank"
                rel="noreferrer"
              >
                <Button>Join Now</Button>
              </a>
            </div>
          </div>
        </div>
        <div className="main-footer-links-wrapper">
          <div className="first-row-container mt-5">
            <div>
              <RealWorldFunding />
              <p className="creator-text mt-4">
                Beyond Traditional Crowdfunding.
              </p>
              {/* <p className="creator-text">Connect with Us</p>
              <div className="social-media-icon-section">
                {socials.map(({ icon = null, link = '' }, index) => (
                  <a href={link} target="_blank" rel="noreferrer" key={index}>
                    <div className="blue-div">{icon}</div>
                  </a>
                ))}
              </div> */}
            </div>
            <div className="all-link-wrapper">
              <div className="link-updates">
                <h4 className="text-white">Main</h4>
                <Link to="/ForCreators">For Brands</Link>
                <Link to="/ForFans">For Backers</Link>
                <Link to="/MarketHub">Discover</Link>
                {/* <Link to="/AboutUs">About Us</Link> */}
                <Link to="/ContactUs">Contact Us</Link>
              </div>
              <div className="link-updates">
                <h4 className="text-white">My Account</h4>
                <Link to="/StakeHub/Profile" onClick={connectWalletHandler}>
                  Profile
                </Link>
                <Link to="/StakeHub" onClick={connectWalletHandler}>
                  StakeHub
                </Link>
                <Link
                  to={hasCreatorAccess ? '/CreatorHub' : '/ForCreators'}
                  onClick={connectWalletHandler}
                >
                  BrandHub
                </Link>
                <Link to="/MarketHub/NFTBucksMarket">Get RWA Tickets</Link>
                <Link
                  to="/StakeHub/AccessNFT/OpenOrders"
                  onClick={connectWalletHandler}
                >
                  Orders
                </Link>
              </div>
              <div className="link-updates">
                <h4 className="text-white">Community</h4>
                <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(STARSTAKE_BRANDCLUB_URL);
                  }}
                >
                  Join Our Campaign
                </Link>
                {/* <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://starhub.starstake.com/');
                  }}
                >
                  StarHub App
                </Link> */}
                {/* <Link to="/ComingSoon">Shop</Link> */}
                <Link to="/StarStakeGuidelines">Guidelines</Link>
                {/* <Link to="/ComingSoon"># Real World Funders</Link> */}
              </div>
              <div className="link-updates">
                <h4 className="text-white">Resources</h4>
                {/* <Link
                  to="/StakeHub/TrainingCenter"
                  onClick={connectWalletHandler}
                >
                  Training Center
                </Link> */}
                {/* <a
                  href="https://intercom.help/starstake/en"
                  target="_blank"
                  rel="noreferrer"
                >
                  Get Help
                </a> */}
                <Link to="/StarStakeGuidelines/FAQ">FAQ</Link>
                {/* <a
                  href="https://news.intercom.com/starstake"
                  target="_blank"
                  rel="noreferrer"
                >
                  News
                </a> */}
                <Link to="/StarStakeGuidelines/Legal">Legal</Link>
              </div>
            </div>
          </div>
          <div className="first-row-container">
            <p className="blue-grey-text mb-0">
              {new Date().getFullYear() || 2023} Real World Asset™ All rights reserved
            </p>
            <div className="trust-security-div">
              <Link to="/StarStakeGuidelines/TrustAndSecurity">
                Trust & Security
              </Link>
              <Link to="/StarStakeGuidelines/TermsOfService">
                Terms of Service
              </Link>
              <Link to="/StarStakeGuidelines/Privacy">Privacy Policy</Link>
            </div>
          </div>
          <div className="bottom-text">
            Disclaimer: Real World Asset is not an investment platform. The purpose of
            Real World Asset is for Brands and Backers to interact – like a digital fan
            club. Brands and Backers must read the terms of service before
            engaging in any purchases or sales on the Real World Asset platform. No
            products or NFTs sold on Real World Asset, should be expected to appreciate
            in value. By using the Real World Asset platform, you agree that Real World Asset
            has not made any promises about the results of taking any action or
            making any purchases. Purchasing an NFT and holding an NFT without
            active engagement does not fulfill the purpose of a Creator’s NFT.
            NFTs sold on the Real World Asset platform are sold to provide rewards and
            perks to backers to share in the digital backer club.
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewFooter;

const socials = [
  {
    icon: socialIcons.facebook,
    link: 'https://www.facebook.com/profile.php?id=100084480344095'
  },
  { icon: socialIcons.instagram, link: 'https://www.instagram.com/star_stake' },
  { icon: socialIcons.twitter, link: 'https://twitter.com/star_stake' },
  { icon: socialIcons.youtube, link: 'https://www.youtube.com/c/Starstake' },
  {
    icon: socialIcons.linkedin,
    link: 'https://www.linkedin.com/company/starstake'
  }
];
